// src/api/hrm/tasks/task_tag_info.js
import axiosInstance from "../../axiosInstance";

const BASE_URL = "/hrm/tasks/tags";

/* ---------------------------------------------
 📌 Lấy danh sách tất cả tag
---------------------------------------------- */
export const getTaskTags = async () => {
  try {
    const res = await axiosInstance.get(BASE_URL);
    return res.data; // [{id, tag_name, color, ...}]
  } catch (error) {
    console.error("❌ getTaskTags error:", error);
    throw new Error("Không thể tải danh sách tag");
  }
};

/* ---------------------------------------------
 📌 Tạo tag mới
---------------------------------------------- */
export const createTaskTag = async (data) => {
  try {
    const res = await axiosInstance.post(BASE_URL, data);
    return res.data;
  } catch (error) {
    const msg = error?.response?.data?.message || "Không thể tạo tag";
    console.error("❌ createTaskTag error:", msg, error);
    throw new Error(msg);
  }
};

/* ---------------------------------------------
 📌 Cập nhật tag
---------------------------------------------- */
export const updateTaskTag = async (id, data) => {
  try {
    const res = await axiosInstance.put(`${BASE_URL}/${id}`, data);
    return res.data;
  } catch (error) {
    const msg = error?.response?.data?.message || "Không thể cập nhật tag";
    console.error("❌ updateTaskTag error:", msg, error);
    throw new Error(msg);
  }
};

/* ---------------------------------------------
 📌 Xóa tag
---------------------------------------------- */
export const deleteTaskTag = async (id) => {
  try {
    const res = await axiosInstance.delete(`${BASE_URL}/${id}`);
    return res.data;
  } catch (error) {
    const msg = error?.response?.data?.message || "Không thể xóa tag";
    console.error("❌ deleteTaskTag error:", msg, error);
    throw new Error(msg);
  }
};
